import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios';

import { isTokenExpired } from '@/services/jwt.service';

Vue.use(Router);

const routes = [
  {
    path: '/',
    component: () => import('../components/Home.vue'),
    children: [
      {
        path: '',
        name: 'Background',
        component: () => import('../components/Background.vue'),
      },
      {
        path: '/form',
        name: 'Form',
        component: () => import('../components/Form.vue'),
      },
      {
        path: '/report',
        name: 'Report',
        component: () => import('../components/Report.vue'),
      },
      {
        path: '/plan',
        name: 'Plan',
        component: () => import('../components/Plan.vue'),
      },
      {
        path: '/report-export',
        name: 'ReportExport',
        component: () => import('../components/ReportExport.vue'),
      },
      {
        path: '/report-analytics',
        name: 'ReportAnalytics',
        component: () => import('../components/ReportAnalytics.vue'),
      },
      {
        path: '/roi-calculator',
        name: 'ROICalculator',
        component: () => import('../components/ROICalculator.vue'),
      },
    ]
  },
  {
    path: '/authorize',
    name: 'Authorized',
    component: () => import('../components/Authorized.vue'),
  }
];

const checkAuth = (to, from, next) => {
  // Check if route's being authorized and if it is
  // have the user "log in" and store token locally

  if (to.path === '/authorize') {
    next();
  } else if (!isTokenExpired()) {
    axios.defaults.headers.Authorization = `Bearer ${localStorage.getItem('id_token')}`;
    next();
  } else if (isTokenExpired()) {
    localStorage.removeItem('id_token');
    window.location.href = `${process.env.VUE_APP_API_URL}ford_oidc`;
  }
};

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach(checkAuth);

export default router;
